export default "__VITE_ASSET__C1vd6kYV__"